import { Box, Typography } from '@mui/material';
import { Update } from '.';
import file from 'assets/images/file.svg';
import Link from 'components/Link';

export const UpdateComponent = ({
  update: { fileName, fileUrl, videoName, videoUrl },
}: {
  update: Update;
}) => {
  return (
    <Box>
      <Typography gutterBottom fontWeight={600}>
        {videoName}
      </Typography>
      <video width="100%" controls>
        <source src={videoUrl} />
        Your browser does not support the video tag.
      </video>

      <Box mt={1} border=".5px solid #949494" display="flex" borderRadius="2px">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            '& img': {
              width: '100%',
            },
          }}
          p={1}
          borderRight=".5px solid #949494"
        >
          <img src={file.src} alt="file icon" />
        </Box>
        <Box display="flex" alignItems="center" pl={1}>
          <Link href={fileUrl} target="_blank" noLinkStyle>
            <Typography fontSize={14}>{fileName}</Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
